import { useEffect } from 'react'
import * as amplitude from '@amplitude/unified'
import { AmplitudeRequiredCookieConsentGroup } from '../../GlobalVariables/Amplitude'
import { AmplitudeInitProps } from '../../types/Scripts'
import { getActiveOneTrustGroups } from '../../utils/onetrust-utils'

let hasInitialized = false

const AmplitudeInit = ({ apiKey, nonce }: AmplitudeInitProps) => {
  useEffect(() => {
    if (typeof window === 'undefined' || !apiKey) return

    const initIfConsented = (): void => {
      if (hasInitialized) return
      if (!getActiveOneTrustGroups().includes(AmplitudeRequiredCookieConsentGroup)) return
      hasInitialized = true
      amplitude
        .initAll(apiKey, {
          serverZone: 'EU',
          analytics: { autocapture: true },
          sessionReplay: { sampleRate: 1 },
          engagement: { nonce },
          experiment: {}
        })
        .then(() => amplitude.experiment()?.start())
    }

    initIfConsented()
    window.addEventListener('OneTrustGroupsUpdated', initIfConsented)
    ;(
      window as { OneTrust?: { OnConsentChanged?(cb: () => void): void } }
    ).OneTrust?.OnConsentChanged?.(initIfConsented)

    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', initIfConsented)
    }
  }, [apiKey])

  return null
}

export default AmplitudeInit
